import {
  Input
} from 'element-ui'

import {
  elementUiVersion
} from '../../utils/constant'

// 在el-form-item设置el-form-item--feedback的时候展示status-icon
const oldNeedStatusIcon = Input.computed.needStatusIcon
Input.computed.needStatusIcon = function () {
  const elFormItemClass  = this.elFormItem && this.elFormItem.$vnode.data.staticClass

  return (oldNeedStatusIcon && oldNeedStatusIcon.call(this)) || elFormItemClass && elFormItemClass.split(' ').includes('el-form-item--feedback')
}

// el-form 验证icon 调整为填充式
Input.computed.validateIcon = function () {
  const flag = elementUiVersion >= 2.8

  return {
    validating: 'el-icon-loading',
    success: flag ? 'el-icon-success' : 'el-icon-circle-check',
    error: flag ? 'el-icon-error' : 'el-icon-circle-check'
  }[this.validateState]
}

// 把element组件内的input事件回调拦截下来
const oldInputHanler = Input.methods.handleInput

Input.methods.handleInput = function (e) {
  const value = e.target.value
  const hasBeforeInput = this._events['before-input'] || this._events['beforeInput']
  const compositionFlag = ('isOnComposition' in this && 'isOnComposition') || ('isComposing' in this && 'isComposing')

  const setValue = (result) => {
    oldInputHanler.call(this, {
      target: {
        value: result
      }
    })

    if (!this[compositionFlag]) {
      e.target.value = result
    }
  }

  if (hasBeforeInput) {
    this.$emit('before-input', setValue, value)
    this.$emit('beforeInput', setValue, value)
  } else {
    oldInputHanler.call(this, {
      target: {
        value
      }
    })
  }
}
